export default "__VITE_ASSET__BVSPtw27__"